export default "__VITE_ASSET__Ugcre_Js__"